<script>
import * as Swiper from '@/node_modules/swiper/swiper-bundle.min.js'
import popupPreview from '@utils/popup-preview.js'
import noImg from '@img/map/noimage.png'
import { mapState } from 'vuex'

export default {
  components: {},
  data() {
    return {
      swiper: null,
    }
  },
  computed: mapState({
    brands: (state) => state.coupons.brands,
    selectedBrand: (state) => state.coupons.selectedBrand,
  }),
  watch: {
    brands(newValue, oldValue) {
      this.$nextTick(() => {
        this.swiper.update()
      })
    },
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    async allBrand() {
      if(this.$store.state.coupons.preview !== '') {
        popupPreview();
      }
      else {
        this.$store.dispatch('coupons/clearSelectedBrand')
        try {
          await this.$store.dispatch('coupons/fetchCoupons', true)
        } catch (e) {}
      }
    },
    async selectBrand(brand) {
      if(this.$store.state.coupons.preview !== '') {
        popupPreview();
      }
      else {
        this.$store.dispatch('coupons/selectBrand', brand.BRAND_ID)
        try {
          await this.$store.dispatch('coupons/fetchCoupons', false)
        } catch (e) {}
      }
    },
    brandCss(brand) {
      if (this.selectedBrand === brand.BRAND_ID) {
        return [
          this.$style.item,
          this.$style.onclick_action_set,
          this.$style.selected_on,
        ]
      } else {
        return [this.$style.item, this.$style.onclick_action_set]
      }
    },
    initSwiper() {
      this.swiper = new Swiper('.swiper-container', {
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
      this.$refs.swiperButtonPrev.removeAttribute('tabindex')
      this.$refs.swiperButtonNext.removeAttribute('tabindex')
    },
    replaceImageByDefault(e) {
      e.target.src = noImg
    }
  },
}
</script>

<template>
  <div :id="$style.slide_area">
    <div :class="['swiper-container', $style['swiper-container']]">
      <div class="swiper-wrapper">
        <div :class="['swiper-slide', $style['swiper-slide']]">
          <div
            :class="[$style.item, $style.onclick_action_set]"
            @click="allBrand"
          >
            <img src="@assets/img/coupon_list/shop_all.png" />
          </div>
        </div>
        <!-- coupon_list.jsにデータ配列を記述、また、通常遷移とは違うようなので、aタグでなく、divタグにして、同jsにクリックイベントを発火させる処理を記述 -->
        <div
          v-for="(brand, index) in brands"
          :key="index"
          :class="['swiper-slide', $style['swiper-slide']]"
        >
          <div
            v-if="brand.BRAND_IMAGE"
            :class="brandCss(brand)"
            @click="selectBrand(brand)"
          >
            <img :src="brand.BRAND_IMAGE" @error="replaceImageByDefault" />
          </div>
        </div>
      </div>
    </div>
    <div
      ref="swiperButtonPrev"
      :class="['swiper-button-prev', $style['swiper-button-prev']]"
    >
      <img src="@assets/img/arrow_L.png" />
    </div>
    <div
      ref="swiperButtonNext"
      :class="['swiper-button-next', $style['swiper-button-next']]"
    >
      <img src="@assets/img/arrow_R.png" />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '~@assets/css/brand-list.scss';
</style>
